import styled from "styled-components";
import { motion } from "framer-motion";
import { COLORS, TEXT_COLORS, BACKGROUND_COLORS, BORDER_COLORS, LAYER_COLORS } from "../../constants/design/colors";
import { FONT_SIZE } from "../../constants/design/fontSize";
import { SPACING } from "../../constants/design/spacing";

export const TradingParametersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  overflow: scroll;
  padding: ${SPACING.three}px;
  height: calc(100vh - 72px - ${SPACING.three * 2}px);

  svg {
    margin: auto 0;
    margin-right: ${SPACING.two}px;
    stroke: ${COLORS.blue.one};
  }
`;

export const TradingParametersGrid = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: ${SPACING.three}px;
  margin-top: ${SPACING.three}px;
`;

export const ParameterCard = styled.div`
  background: ${LAYER_COLORS.two};
  border: 1px solid ${BORDER_COLORS.one};
  border-radius: 8px;
  padding: ${SPACING.two}px ${SPACING.three}px;
  display: flex;
  flex-direction: column;
  gap: ${SPACING.one}px;
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${SPACING.two}px;
  padding-bottom: ${SPACING.two}px;
  border-bottom: 1px solid ${BORDER_COLORS.two};

  h3 {
    margin: 0;
    font-size: ${FONT_SIZE.three};
    font-weight: 600;
    color: ${TEXT_COLORS.one};
  }

  div {
    display: flex;
    gap: ${SPACING.one}px;
  }
`;

export const ParameterRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${SPACING.one}px 0;

  span {
    font-size: ${FONT_SIZE.one};
    color: ${TEXT_COLORS.two};
  }

  div {
    font-size: ${FONT_SIZE.one};
    color: ${TEXT_COLORS.one};
    font-weight: 500;
  }
`;

export const FormInput = styled.input<{ hasErrors?: boolean }>`
  background: ${BACKGROUND_COLORS.four};
  border: 1px solid ${({ hasErrors }) => (hasErrors ? COLORS.red.one : BORDER_COLORS.one)};
  border-radius: 4px;
  color: ${TEXT_COLORS.one};
  font-size: ${FONT_SIZE.one};
  padding: ${SPACING.one}px ${SPACING.two}px;
  width: 120px;
  text-align: right;

  &:focus {
    outline: none;
    border-color: ${({ hasErrors }) => (hasErrors ? COLORS.red.one : COLORS.blue.one)};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const Button = styled.button<{ variant?: "primary" | "secondary" }>`
  background: transparent;
  border: none;
  border-radius: 4px;
  color: ${({ variant }) => (variant === "secondary" ? TEXT_COLORS.two : COLORS.blue.one)};
  font-size: ${FONT_SIZE.one};
  padding: ${SPACING.one}px ${SPACING.two}px;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: 500;

  &:hover:not(:disabled) {
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const FormError = styled.div`
  color: ${COLORS.red.one};
  font-size: ${FONT_SIZE.xs};
  margin-top: ${SPACING.one}px;
`;

export const HeaderSection = styled.div`
  display: flex;
  align-items: center;
  font-size: ${FONT_SIZE.four};
  font-weight: 600;
  color: ${TEXT_COLORS.one};
  margin-bottom: ${SPACING.two}px;
`;

export const FilterSection = styled.div`
  display: flex;
  gap: ${SPACING.three}px;
  align-items: center;
  margin: ${SPACING.two}px 0;
  flex-wrap: wrap;
`;
